// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-menu {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: var(--primary);
  padding: 8px 0 !important;
  width: 40px;
  overflow: auto;
  color: var(--on-primary-text);
}
.navigation-menu .navigation-menu__item {
  cursor: pointer;
  height: 40px;
  user-select: none;
  text-align: center;
}
.navigation-menu .navigation-menu__item > svg.icon {
  opacity: 0.5;
  font-size: 24px;
}
.navigation-menu .navigation-menu__item.active > svg.icon,
.navigation-menu .navigation-menu__item:hover > svg.icon {
  opacity: 1;
}
.customlink {
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.infoblock {
  position: absolute;
  bottom: 0px;
  display: flex;
  height: 80px;
  width: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.infoblock .iconLinks {
  color: #87b4c7;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.infoblock svg.icon {
  fill: #87b4c7;
}
.infoblock svg.icon:hover {
  fill: #ffffff;
}
.infoblock .iconLinks:hover {
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/navigation-menu/NavigationMenu.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,6BAAA;AAAJ;AAXA;EAcQ,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,YAAA;EACA,eAAA;AAAZ;AAGQ;;EAEI,UAAA;AADZ;AAMA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;AAOA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AALJ;AAHA;EAWQ,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AALR;AATA;EAkBQ,aAAA;AANR;AAZA;EAsBQ,aAAA;AAPR;AAfA;EA0BQ,cAAA;AARR","sourcesContent":[".navigation-menu {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 2;\n\n    background-color: var(--primary);\n    padding: 8px 0 !important;\n    width: 40px;\n    overflow: auto;\n    color: var(--on-primary-text);\n\n    .navigation-menu__item {\n        cursor: pointer;\n        height: 40px;\n        user-select: none;\n        text-align: center;\n\n        &>svg.icon {\n            opacity: 0.5;\n            font-size: 24px;\n        }\n\n        &.active>svg.icon,\n        &:hover>svg.icon {\n            opacity: 1;\n        }\n    }\n}\n\n.customlink {\n    width: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.infoblock {\n    position: absolute;\n    bottom: 0px;\n    display: flex;\n    height: 80px;\n    width: 40px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n\n    .iconLinks {\n        color: #87b4c7;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n    }\n\n    svg.icon {\n        fill: #87b4c7;\n    }\n\n    svg.icon:hover {\n        fill: rgb(255, 255, 255);\n    }\n\n    .iconLinks:hover {\n        color: rgb(255, 255, 255);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
